import { orderTestServiceCloud } from "@/services/orderTestRequest";
import { orderTestServiceCloudV2 } from "@/services/orderTestRequest";

export function multiLogin(params) {
  return orderTestServiceCloud({
    url: "/login/multiLogin",
    method: "post",
    params,
  });
}

export function searchPatientApi(params) {
  return orderTestServiceCloud({
    url: "/orderTest/searchPatient",
    method: "get",
    params,
  });
}

export function addNewPatientApi(data) {
  return orderTestServiceCloud({
    url: "/orderTest/patient",
    method: "post",
    data,
  });
}

export function getPatientByIdApi(params) {
  return orderTestServiceCloud({
    url: "/orderTest/patient",
    method: "get",
    params,
  });
}

export function updatePatientApi(data) {
  return orderTestServiceCloud({
    url: "/orderTest/patient",
    method: "put",
    data,
  });
}

export function getAllTests() {
  return orderTestServiceCloud({
    url: "/orderTest/allTests",
    method: "get",
  });
}


export function getAllTestsTubeInfo() {
  return orderTestServiceCloud({
    url: "/orderTest/allTestsTubeInfo",
    method: "get",
  });
}

export function getExpiredAddonItems(params) {
  return orderTestServiceCloud({
    url: "/orderTest/getExpiredAddonItems",
    method: "get",
    params
  })
}

export function getExpiredSoonAddonItems(params) {
  return orderTestServiceCloud({
    url: "/orderTest/getExpiredSoonAddonItems",
    method: "get",
    params
  })
}

export function getPrevAddOnTubeInfo(params) {
  return orderTestServiceCloud({
    url: "/sampleTubeInfoV2",
    method: "get",
    params
  })
}

export function getCustomPanels() {
  return orderTestServiceCloud({
    url: "/orderTest/customPanel",
    method: 'get',
  });
}

export function getCustomPanelsWTubeInfo() {
  return orderTestServiceCloud({
    url: "/orderTest/customPanel?tubeInfoNeeded=true",
    method: 'get',
  });
}

export function getFavorites() {
  return orderTestServiceCloud({
    url: "/orderTest/favorite",
    method: "get",
  });
}



export function addFavoriteTest(data) {
  return orderTestServiceCloud({
    url: "/orderTest/favorite",
    method: "post",
    data,
  });
}

// export function deleteFavoriteTestById(data) {
//   return orderTestService({
//     url: "/orderTest/favorite",
//     method: "delete",
//     data,
//   });
// }







export function getOfficialBundleMappingRedis() {
  return orderTestServiceCloud({
    url: "/orderTest/officialBundleMappingRedis",
    method: "get",
  });
}

export function createOrderDraft(data) {
  return orderTestServiceCloud({
    url: "/orderTest/orderDraft",
    method: "post",
    data,
  });
}

export function createOrder(data) {
  return orderTestServiceCloud({
    url: "/orderTest/order",
    method: "post",
    data,
  });
}

export function placeOrderV2(data) {
  return orderTestServiceCloudV2({
    url: "/orders",
    method: "post",
    data,
  });
}

export function sharePdf(data) {
  return orderTestServiceCloud({
    url: "/orderTest/sharePdfNew",
    method: "post",
    data,
  });
}

export function getDefaultOrderSettings() {
  return orderTestServiceCloud({
    url: "/orderTest/orderSetting",
    method: "get",
  });
}

export function getOrderResultMap(params) {
  return orderTestServiceCloud({
    url: "/orderTest/fetchOrderResultMap",
    method: "get",
    params
  })
}

export function getOrderResultMapNew(params) {
  return orderTestServiceCloud({
    url: "/orderTest/generateNormalOrderPdf",
    method: "get",
    params
  })
}

export function getOrderDraft(params) {
  return orderTestServiceCloud({
    url: "/orderTest/orderDraft",
    method: "get",
    params,
  });
}

export function getDraftItems() {
  return orderTestServiceCloud({
    url: "/orderTest/orderDraftList?page=1&pageSize=1250",
    method: "get",
  });
}

export function deleteDraftById(draftId) {
  return orderTestServiceCloud({
    url: "/orderTest/orderDraft" + "?orderDraftId=" + draftId,
    method: "delete",
  });
}

export function getPromotionMapping() {
  // return orderTestService({
  //   url: "/orderTest/getPromotionCacheMappingRedis",
  //   method: "get"
  // })
  return [];
}

export function getOrderById(data, isBeta = false) {
  return orderTestServiceCloud({
    url: "/orderTest/orderV2",
    method: "post",
    data,
  });
}

export async function createTubeInfo(data) {
  return orderTestServiceCloud({
    url: "/orderTest/tubeInfoForOrderItemV2",
    method: "post",
    data
  })
}

export function postFavTestList(data) {
  return orderTestServiceCloud({
    url: "orderTest/favoriteList",
    method: "post",
    data
  })
}

export function getProcessingFeeCapOffValue() {
  return orderTestServiceCloud({
    url: "/orderTest/labProcessingFeeCapOffValue",
    method: "get"
  })
}

export function generateSampleIdsApi(params) {
  return orderTestServiceCloud({
    url: "/orderTest/generateSampleIds",
    method: "get",
    params
  })
}

export function isPatientValidFollowUpOrderApi(params) {
  return orderTestServiceCloud({
    url: "/orderTest/isPatientValidFollowUpOrder",
    method: "get",
    params
  })
}

export function getOneTimePurchaseEligibility(params) {
  return orderTestServiceCloud({
    url: "/orderTest/oneTimePurchaseEligibility",
    method: "get",
    params
  })
}

export function getPatientPurchaseEligibility(params) {
  return orderTestServiceCloud({
    url: "/orderTest/patientPurchaseEligibility",
    method: "get",
    params
  })
}

export function isValidConciergeFeeApi(data) {
  return orderTestServiceCloud({
    url: "/orderTest/isValidConciergeFee",
    method: "post",
    data
  })
}

export function isValidConciergeFeeV2Api(data) {
  return orderTestServiceCloud({
    url: "/orderTest/isValidConciergeFeeV2",
    method: "post",
    data
  })
}

export function getQuestionnaireRequiredMap(params) {
  return orderTestServiceCloud({
    url: "/orderTest/getQuestionnaireRequiredMap",
    method: "get",
    params
  })
}

export function postFamilyOrdersApi(data) {
  return orderTestServiceCloud({
    url: "/orderTest/familyOrders",
    method: "post",
    data
  })
}

export function listPatientsByAddress(data) {
  return orderTestServiceCloudV2({
    url: "/patient/listPatientsByAddress",
    method: "post",
    data,
  });
}